import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
/**
 * @example
 * ```
 *  <NotificationBlock message="-- End Of Content --" class="uxpcore_notification--end-of-content" />
 *  <NotificationBlock message="Something went wrong" variant="danger" />
 *  <NotificationBlock message="Saved successfully" variant="success" />
 * ```
 * @export
 */
const NotificationBlock = (props) => {
    const { message, variant, mode, layout, styles, class: extraClass } = props;
    return (_jsx("div", { className: classNames('uxpcore_notification', { [`uxpcore_notification--${variant}`]: variant }, { 'uxpcore_notification--compact': mode === 'compact' }, { 'uxpcore_notification--bordered': layout === 'bordered' }, extraClass), style: styles || {}, children: message }));
};
export default NotificationBlock;
